// import React, { useState } from "react";
// import { Link } from "react-router-dom"; 
// import "./Header.css";

// const Header = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   return (
//     <header className="header">
//       <div className="header-top">
//        <h1 className="site-title">
//       <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
//         JOBKART
//       </Link>
//     </h1>
//     <p className="site-subtitle">
//       <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
//         jobkart.com
//       </Link>
//     </p>
//         {/* Hamburger for small screens */}
//         <button className="menu-toggle" onClick={toggleMenu}>
//           ☰
//         </button>
//       </div>

//       <nav className={`navbar ${isMenuOpen ? "open" : ""}`}>
//         <ul className="nav-menu">
//           <li><a href="/">Home</a></li>
//           <li><a href="/all-jobs">Latest Job</a></li>
//           <li><a href="/all-admit-cards">Admit Card</a></li>
//           <li><a href="/all-results">Result</a></li>
//           <li><a href="/admission">Admission</a></li>
//           <li><a href="/syllabus">Syllabus</a></li>
//           <li><a href="/more">More</a></li>
//         </ul>
//       </nav>
//     </header>
//   );
// };

// export default Header;




// ---------------------------------------------------doubel color header---------------------
import React from "react";
import { Link } from "react-router-dom";
import "./Header.css";

const Header = () => {
  return (
    <header className="header">
      <div className="header-top">
        {/* <h1 className="site-title">
          <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
            IndianJobs360
          </Link>
        </h1> */}
        <h1 className="site-title">
            <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
              IndianJobs<span className="highlight-360">360</span>
            </Link>
          </h1>
        <p className="site-subtitle">
          <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
            IndianJobs360.com
          </Link>
        </p>
      </div>

      <nav className="navbar">
        <ul className="nav-menu">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/all-jobs">Latest Job</Link></li>
          <li><Link to="/all-admit-cards">Admit Card</Link></li>
          <li><Link to="/all-results">Result</Link></li>
          <li><Link to="/more">More</Link></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
